<template>
  <section class="vault-page space-y-12">

    <!-- ================= VAULT HEADER ================= -->
    <div class="vault-header">
      <div>
        <h1>Send Boardcast</h1>
        <p>
          Send messages to your verified fans instantly. Share updates, images, links, or polls to engage your audience and strengthen your creator community.
        </p>
      </div>

     
    </div>

      <section class="pb-20 space-y-6">
    <h3 class="text-3xl font-bold">Broadcast Node</h3>
    <div class="bg-white rounded-[2.5rem] p-10 premium-shadow border border-slate-50">
      <textarea v-model="broadcast" class="w-full bg-slate-50 rounded-2xl p-8 text-xl min-h-[160px]"
        placeholder="Type a message to your verified audience..." />
      <div class="mt-8 flex items-center justify-between">

        <!-- Left: Action Icons -->
        <div class="flex gap-2">

  <button class="size-12 rounded-xl hover:bg-slate-50 text-slate-400 hover:text-slate-900
     transition-all flex items-center justify-center" 
     title="Add Image"
     @click="broadcastType = 'IMAGE'"
     :class="broadcastType === 'IMAGE' ? 'bg-slate-900 text-white' : ''">

    <i class='bx bx-image text-xl'></i>

  </button>

  <button class="size-12 rounded-xl hover:bg-slate-50 text-slate-400 hover:text-slate-900
     transition-all flex items-center justify-center" 
     title="Add Link"
     @click="broadcastType = 'LINK'"
     :class="broadcastType === 'LINK' ? 'bg-slate-900 text-white' : ''">

    <i class='bx bx-link text-xl'></i>

  </button>

  <button class="size-12 rounded-xl hover:bg-slate-50 text-slate-400 hover:text-slate-900
     transition-all flex items-center justify-center" 
     title="Create Poll"
     @click="broadcastType = 'POLL'"
     :class="broadcastType === 'POLL' ? 'bg-slate-900 text-white' : ''">

    <i class='bx bx-bar-chart-alt-2 text-xl'></i>

  </button>

</div>

        <!-- Right: Send Button -->
        <button @click="sendBroadcast()" class="bg-primary text-white font-bold px-10 py-4 rounded-xl
           hover:opacity-90 transition-all
           flex items-center gap-3 text-[13px] uppercase tracking-wider">
          {{isLoading?"Sending...":"Send to "+totalFans+" Fans"}}
          <i class='bx bx-send text-[18px]'></i>
        </button>

      </div>

      <div v-if="broadcastType === 'IMAGE'" class="mt-6">
        <input type="file" @change="handleImage" class="text-sm" />
      </div>
      <div v-if="broadcastType === 'LINK'" class="mt-6">
        <input 
          v-model="broadcastLink"
          class="w-full bg-slate-50 rounded-xl p-4 text-sm"
          placeholder="Paste URL…" />
      </div>
      <div v-if="broadcastType === 'POLL'" class="mt-6 space-y-3">

        <input v-model="pollQuestion"
          class="w-full bg-slate-50 rounded-xl p-4 text-sm"
          placeholder="Poll question…" />

        <input v-model="pollOption1"
          class="w-full bg-slate-50 rounded-xl p-4 text-sm"
          placeholder="Option 1" />

        <input v-model="pollOption2"
          class="w-full bg-slate-50 rounded-xl p-4 text-sm"
          placeholder="Option 2" />

      </div>


    </div>
  </section>

  </section>
</template>

<script>
import { useToast } from "vue-toastification";
import { sendBroadcastApi,loadInfluencerDashboardApi } from "../apis/influencerapis";

export default {

  name: "VaultScreen",

  data() {
    return {
      isLoading: false,
    broadcast: "",
    broadcastType: "",
    broadcastImage: null,
    broadcastLink: "",
    pollQuestion: "",
    pollOption1: "",
    pollOption2: "",
    toast: null,
    user_id: "",
    totalFans:0
    };
  },

  mounted() {

    this.toast = useToast();
     const ldataRaw = sessionStorage.getItem("ldata");
      const ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      if(ldata!=null){
        this.user_id = ldata.user_id;
        this.loadDashboard(this.user_id);
      }
  },

  methods: {
     async loadDashboard(user_id) {

        const res = await loadInfluencerDashboardApi(user_id);

        if (!res.status) {
          this.toast.error("Dashboard load failed");
          return;
        }

        this.totalFans = res.kpis[0].value || 0;

      },
     setBroadcastType(type) {

        this.broadcastType = type;

        // Reset state safely
        this.broadcastImage = null;
        this.broadcastLink = "";

        this.pollQuestion = "";
        this.pollOption1 = "";
        this.pollOption2 = "";
      }
      ,
      handleImage(e) {
        this.broadcastImage = e.target.files[0];
      }
      ,
      buildBroadcastPayload() {
        const payload = {
          type: this.broadcastType,
          message: this.broadcast
        };

        if (this.broadcastType === "LINK") {
          payload.link = this.broadcastLink;
        }

        if (this.broadcastType === "POLL") {

          const options = [this.pollOption1, this.pollOption2]
            .filter(opt => opt && opt.trim() !== "");

          if (options.length < 2) {
            this.toast.warning("Enter at least 2 valid options");
            return null;
          }

          payload.poll = {
            question: this.pollQuestion.trim(),
            options
          };
        }

        return payload;
      }
      ,
      async sendBroadcast() {

        if (!this.broadcast.trim()) {
          this.toast.warning("Write something first");
          return;
        }

        if (this.broadcastType === "LINK" && !this.broadcastLink) {
          this.toast.warning("Enter a link");
          return;
        }

        if (this.broadcastType === "IMAGE" && !this.broadcastImage) {
          this.toast.warning("Select an image");
          return;
        }

        if (this.broadcastType === "POLL" && !this.pollQuestion) {
          this.toast.warning("Enter poll question");
          return;
        }

        const payload = this.buildBroadcastPayload();

        const user = JSON.parse(sessionStorage.getItem("ldata"));

        if (!user) return;

        this.isLoading = true;

        const res = await sendBroadcastApi(
          user.user_id,
          payload,
          this.broadcastImage

        );
        this.isLoading = false;
        if (!res.status) {
          this.toast.error(res.success || "Broadcast failed");
          return;
        }

        this.toast.success("Broadcast sent 🚀");

        this.broadcast = "";

        // Optional live UI refresh
        await this.loadDashboard(user.user_id);
      },
  }
};

</script>


<style scoped>
.vault-page {
  max-width: 1440px;
  margin: auto;
  padding-bottom: 120px;
}

.vault-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vault-header h1 {
  font-size: 40px;
  font-weight: 800;
}

.vault-header p {
  color: #94a3b8;
  margin-top: 6px;
}

.vault-status {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ecfdf5;
  color: #047857;
  padding: 10px 14px;
  border-radius: 999px;
  font-weight: 700;
}

.vault-card {
  background: white;
  border-radius: 32px;
  padding: 32px;
  box-shadow: 0 8px 40px -12px rgba(0,0,0,0.08);
}

.vault-card .label {
  font-size: 11px;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: #94a3b8;
}

.vault-card h2 {
  font-size: 36px;
  font-weight: 800;
  margin-top: 6px;
}

.vault-section {
  background: white;
  border-radius: 32px;
  padding: 40px;
  box-shadow: 0 8px 40px -12px rgba(0,0,0,0.08);
}

.vault-section.highlight {
  border: 1px solid #e2e8f0;
}

.section-desc {
  color: #94a3b8;
  margin-top: 8px;
  margin-bottom: 24px;
}

.ledger {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.ledger-item {
  background: #f8fafc;
  padding: 20px;
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
  font-weight: 700;
}

.control-list .control-row {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
}

.control-row.locked {
  opacity: 0.5;
}

.locked-pill {
  font-size: 11px;
  background: #f1f5f9;
  padding: 4px 10px;
  border-radius: 999px;
}

.insurance-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.plan-name {
  font-weight: 800;
}

.protection-list {
  margin-top: 24px;
  line-height: 1.9;
  font-weight: 600;
}

.expiry-note {
  margin-top: 20px;
  color: #94a3b8;
  font-size: 14px;
}

.activity-log {
  list-style: none;
  padding: 0;
}

.activity-log li {
  display: flex;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
}

.activity-log .dot {
  width: 8px;
  height: 8px;
  background: #0f172a;
  border-radius: 50%;
  margin-top: 6px;
}

.muted {
  color: #94a3b8;
  font-size: 13px;
}

.primary-btn {
  background: #0f172a;
  color: white;
  padding: 14px 22px;
  border-radius: 14px;
  font-weight: 700;
}

.ghost-btn {
  font-weight: 700;
  color: #0f172a;
}

/* Mobile */
@media (max-width: 768px) {
  .ledger {
    grid-template-columns: 1fr;
  }

  .insurance-box {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }
}
/* ===============================
   VAULT – GLOBAL HELPERS
   =============================== */

/* Page spacing safety */
.space-y-12 > * + * {
  margin-top: 3rem;
}

/* Typography helpers */
h1, h2, h3 {
  letter-spacing: -0.02em;
}

h3 {
  font-size: 1.5rem;
  font-weight: 800;
}

/* ===============================
   BUTTONS (shared)
   =============================== */

.primary-btn {
  background: #0f172a;
  color: #ffffff;
  padding: 14px 22px;
  border-radius: 14px;
  font-weight: 700;
  transition: opacity 0.2s ease;
}

.primary-btn:hover {
  opacity: 0.9;
}

.ghost-btn {
  background: transparent;
  color: #0f172a;
  font-weight: 700;
  padding: 12px 16px;
  border-radius: 12px;
}

.ghost-btn:hover {
  background: #f8fafc;
}

/* ===============================
   STATUS / PILLS
   =============================== */

.locked-pill {
  font-size: 11px;
  font-weight: 800;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
}

/* ===============================
   CHECKBOX / TOGGLE (Vault)
   =============================== */

input[type="checkbox"] {
  appearance: none;
  width: 40px;
  height: 22px;
  background: #e5e7eb;
  border-radius: 999px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease;
}

input[type="checkbox"]::after {
  content: "";
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: transform 0.2s ease;
}

input[type="checkbox"]:checked {
  background: #0f172a;
}

input[type="checkbox"]:checked::after {
  transform: translateX(18px);
}

/* ===============================
   VAULT SPECIFIC
   =============================== */

.vault-section h3 {
  margin-bottom: 6px;
}

.vault-section ul {
  padding-left: 0;
  list-style: none;
}

.vault-section ul li {
  margin-bottom: 8px;
}

/* Ledger */
.ledger strong {
  font-size: 18px;
}

/* Activity log */
.activity-log li:last-child {
  border-bottom: none;
}

/* ===============================
   MOBILE SAFETY
   =============================== */

@media (max-width: 768px) {

  .vault-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .vault-header h1 {
    font-size: 28px;
  }

  .vault-card h2 {
    font-size: 28px;
  }

  .vault-section {
    padding: 28px;
  }
}

/* Extra small */
@media (max-width: 420px) {
  .vault-card,
  .vault-section {
    border-radius: 20px;
  }
}
/* ===============================
   TWO COLUMN VAULT ROW
   =============================== */

.vault-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

/* Mobile fallback */
@media (max-width: 900px) {
  .vault-row-2 {
    grid-template-columns: 1fr;
  }
}

  .input-field {
  width: 100%;
  background: #f8fafc;              /* matches slate-50 */
  border-radius: 16px;
  padding: 14px 18px;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  border: 1px solid transparent;
  transition: all 0.25s ease;
}

.input-field::placeholder {
  color: #94a3b8;                   /* slate-400 */
  font-weight: 500;
}

.input-field:focus {
  outline: none;
  border-color: #0f172a;
  background: white;
  box-shadow: 0 0 0 4px rgba(15, 23, 42, 0.05);
}

.file-input {
  width: 100%;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.file-input::file-selector-button {
  background: #0f172a;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  margin-right: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.file-input::file-selector-button:hover {
  opacity: 0.85;
}
.poll-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.dynamic-field {
  animation: fadeSlide 0.25s ease;
}

@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
